export const UPDATE_CHECK_IN_SETTINGS_STARTED = "UPDATE_CHECK_IN_SETTINGS_STARTED"
export const UPDATE_CHECK_IN_SETTINGS_SUCCESS = "UPDATE_CHECK_IN_SETTINGS_SUCCESS"
export const UPDATE_CHECK_IN_SETTINGS_FAILURE = "UPDATE_CHECK_IN_SETTINGS_FAILURE"

export const GET_CHECK_IN_SETTINGS_STARTED = "GET_CHECK_IN_SETTINGS_STARTED"
export const GET_CHECK_IN_SETTINGS_SUCCESS = "GET_CHECK_IN_SETTINGS_SUCCESS"
export const GET_CHECK_IN_SETTINGS_FAILURE = "GET_CHECK_IN_SETTINGS_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
